import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

@Component({
    selector: 'app-courses-grid-style-two-columns-four-page',
    templateUrl: './courses-grid-style-two-columns-four-page.component.html',
    styleUrls: ['./courses-grid-style-two-columns-four-page.component.scss']
})
export class CoursesGridStyleTwoColumnsFourPageComponent implements OnInit {

    isToggled = false;
	
    constructor(
        public themeService: ThemeCustomizerService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void {}

}